import { useState, useEffect } from 'react';
import api from './axiosConfig';

// 🎯 بيجيب قايمة التطبيقات الكستم المنشورة واللي اليوزر الحالي عنده صلاحية
// عليها - ده اللي بيقرأه Header.js وSidebar.js عشان يضيفوا مجموعة "Custom
// Applications" ديناميكيًا بدل ما تتكتب يدوي زي باقي المجموعات.
export const useCustomAppsMenu = () => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get('/custom-apps/menu')
      .then((res) => { if (alive) setApps(res.data || []); })
      .catch(() => { if (alive) setApps([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return { apps, loading };
};

export default useCustomAppsMenu;
